import React, { ReactNode } from 'react'
import { LinkContainer } from './Link.style'

interface LinkProps {
    children: ReactNode
    onClick: () => void
    disabled?: boolean
    className?: string
}

const Link = ({ children, onClick, disabled = false, className }: LinkProps) => {
    return (
        <LinkContainer onClick={onClick} $disabled={disabled} className={className}>
            {children}
        </LinkContainer>
    )
}

export default Link
